var React = require('react');

function PrevArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.70679 0.293C8.89426 0.480528 8.99957 0.734836 8.99957 1C8.99957 1.26516 8.89426 1.51947 8.70679 1.707L2.41379 8L8.70679 14.293C8.88894 14.4816 8.98974 14.7342 8.98746 14.9964C8.98518 15.2586 8.88001 15.5094 8.6946 15.6948C8.5092 15.8802 8.25838 15.9854 7.99619 15.9877C7.73399 15.99 7.48139 15.8892 7.29279 15.707L0.292787 8.707C0.105316 8.51947 0 8.26516 0 8C0 7.73484 0.105316 7.48053 0.292787 7.293L7.29279 0.293C7.48031 0.105529 7.73462 0.000213623 7.99979 0.000213623C8.26495 0.000213623 8.51926 0.105529 8.70679 0.293Z","fill":"#3D2B30"}));
}

PrevArrow.defaultProps = {"width":"9","height":"16","viewBox":"0 0 9 16","fill":"none"};

module.exports = PrevArrow;

PrevArrow.default = PrevArrow;
